import axios from 'axios';

const AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.wemaza.com',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

let isRedirecting = false;

// ✅ Intercepteur de réponse : gestion des 401 sans boucle de redirection
AxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isLoginPage = window.location.pathname === '/' || window.location.pathname === '/signin';
      if (!isLoginPage && !isRedirecting) {
        isRedirecting = true;
        console.warn("Session invalide ou expirée. Redirection vers la page de connexion...");
        localStorage.removeItem('user');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default AxiosInstance;

